import React from "react";

export const RightWrapperHeader = ({ children }) => (
  <div className="w-full bg-blue-500 text-white p-4 rounded-lg shadow-md">
    {children}
  </div>
);

export const RightWrapperFooter = ({ children }) => (
  <div className="w-full bg-gray-800 text-white p-4 mt-6 rounded-lg text-center">
    {children}
  </div>
);

const RightWrapper = ({ children, className = "" }) => {
  // Extract specific children based on their type
  const header = React.Children.toArray(children).find(
    (child) => child.type === RightWrapperHeader
  );

  const footer = React.Children.toArray(children).find(
    (child) => child.type === RightWrapperFooter
  );

  // Render the Wrapper
  return (
    <div className="flex flex-col items-center justify-center h-full pt-5 p-2 md:pl-0 md:pt-0  md:pb-0">
      {/* Render Header if Provided */}
      {header && header}

      {/* Render the rest of the content */}
      <div className={`w-full h-full max-h-full md:pt-14 pt-8 ${className}`}>
        {React.Children.toArray(children).filter(
          (child) =>
            child.type !== RightWrapperHeader &&
            child.type !== RightWrapperFooter
        )}
      </div>

      {/* Render Footer if Provided */}
      {footer && footer}
    </div>
  );
};

export default RightWrapper;
